import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { decodeHTMLEntities } from '@app/helpers/helpers';
import { ErrorService } from '@app/services/error.service';
import { ModalService } from '@app/services/modal.service';
import { SessionService } from '@app/services/session/session.service';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
//import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'ngx-webstorage';
import { catchError, Observable, of, tap, throwError } from 'rxjs';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  excludedUrls = [
    'checkEseal', // checkEseal service
    'file?format', // download certificate
    'lcert-lokalise-pr-bucket', //translations files
    'languages', //translations files
    'idp.infocert.it', // OAuth2/ISAC endpoints
    'idpcl.infocert.it',
    'idp.eu-south-1.tsaws.infocert.it',
  ];
  plainErrorUrls = ['rekey'];
  constructor(
    //public toasterService: ToastrService,
    public errorService: ErrorService,
    public modalService: ModalService,
    public sessionService: SessionService,
    private localStorageService: LocalStorageService,
    private readonly injector: Injector,
    private bsModalService: BsModalService
  ) {}

  correlationIdMessage: string;

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let translateService: TranslateService;
    try {
      translateService = this.injector.get(TranslateService);
      // log using translate service
    } catch {
      // log without translation translation service is not yet available
    }

    const url = req.url as string;

    console.log('🚀 ~ HttpResponseInterceptor ~ url', url);
    if (
      //Se appartiene agli url ignorati
      this.excludedUrls.some(excludeUrl => url.includes(excludeUrl)) ||
      //Se contiene l'header "ignoreInterceptor"
      req.headers.has('ignoreInterceptor')
    ) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
          if (evt.ok)
            //this.toasterService.success("Success", JSON.stringify(evt.body, null, 2), { positionClass: 'toast-bottom-center' });
            console.log(evt.url, evt.status, evt.body);
        }
      }),
      catchError((err: any) => {
        debugger;
        if (err instanceof HttpErrorResponse) {
          const status = err.status;

          // Ignora errori "status: 0" per l'URL /ncfr-api/otp per ignorare la validazione del numero di telefono
          if (status === 0 && (err.url?.includes('/ncfr-api/otp') ?? false)) {
            console.warn('Ignorato errore di rete su /ncfr-api/otp:', err);
            return throwError(() => err);
          }

          const skipErrorModal =
            sessionStorage.getItem('skipErrorModal') === 'true';
          if (skipErrorModal) {
            return throwError(() => err);
          }

          let errorMessage = decodeHTMLEntities(
            err?.error?.description || 'Errore generico'
          );

          let errorCode = decodeHTMLEntities(err?.error?.code || 'E_GENERIC');

          if (err?.error?.error) {
            console.log('[ERROR]', err?.error?.error);
            errorMessage = decodeHTMLEntities(err?.error?.error);
            errorCode = decodeHTMLEntities('E_UNAUTHORIZED');
          }

          const translatedMessage =
            translateService.instant(`SERVER_ERRORS.${errorCode}`) ||
            errorMessage ||
            errorCode;

          console.log('🚀 ~ HttpResponseInterceptor ~ translatedMessage', {
            errorMessage,
            errorCode,
            translatedMessage,
          });

          try {
            const url = err.url as string;
            // error code list that disables toast from showing
            const ignoreCodes = ['E_NOT_FOUND', 'MS_NTF_004'];

            console.log('HttpResponseInterceptor', url);
            if (
              !this.excludedUrls.some(excludeUrl => url.includes(excludeUrl)) &&
              !ignoreCodes.includes(errorCode)
            ) {
              //metto il correlationId nel messaggio di codice d'errore
              this.correlationIdMessage = translateService.instant(
                'ERROR_MODAL.ERROR_CODE',
                {
                  errorCode: localStorage.getItem('correlationId'),
                }
              );
              //apro la modale o il toast d'errore in base al tipo di errore segnalato
              this.errorService.showError(
                translatedMessage,
                errorCode,
                this.correlationIdMessage
              );
            }
          } catch (e) {
            //apro la modale ol toast d'errore in base all'errore segnalato
            this.errorService.showError(
              translatedMessage,
              errorCode,
              this.correlationIdMessage
            );
          }

          switch (errorCode) {
            case 'E_UNAUTHORIZED':
              this.sessionService.logout();
              break;
            case 'MS_NTF_004':
              this.localStorageService.store('session-error-code', errorCode);
              break;
            default:
              // do nothing
              break;
          }
          //Se ricevo un 401 (sessione scaduta) devo fare il logout
          if (status === 401) {
            //chiudo la modale di errore per non farla apparire sulla landing quando accedo ma non ho fatto logout prima di chiudere la tab la volta precedente
            this.bsModalService.hide('error');
            this.sessionService.logout();
          }

          //log error
        }
        //se nell'header c'è plainError ritorno l'errore non come observable
        if (req.headers.has('plainError')) {
          return throwError(() => err);
        } else {
          //altrimenti ritorno l'errore come observable
          throw of(err);
        }
      })
    );
  }
}
